import API from '../../../../../services/api';

export const SCRAPPER_API = {
    scrappingURL: async (url) => {
        return API.post('/scrapping', {url: url.url}).then(res => res.data);
    },
    scrappingRef: async (marketplaces, ref) => {
        return API.post('/scrappingRef', {marketplaces, ref}).then(res => res.data);
    },
    completeScrappingInfo: async (part) => {
        return API.post('/scrappingByRef', {part: part}).then(res => res.data);
    },
    scrappingBlatRef: async (tipo, referencia, filtros, id) => {
        return API.post('/blat/referencia', { tipo, referencia, filtros, id }).then((res) => res.data);
    },
    scrappingBlatFilters: async (tipo, referencia, endpoint) => {
        return API.post('/blat/filtros', { tipo, referencia, endpoint }).then((res) => res.data);
    },
    scrappingBlatURL: async (url, id) => {
        return API.post('/blat/url', { url, id }).then((res) => res.data);
    }
}